export const licensesNumbers = Array.from(Array(101).keys());
